module["exports"] = [
  "(+995 32) 2-##-##-##",
  "032-2-##-##-##",
  "032-2-######",
  "032-2-###-###",
  "032 2 ## ## ##",
  "032 2 ######",
  "2 ## ## ##",
  "2######",
  "2 ### ###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ge/cell_phone/formats.js
 ** module id = 637
 ** module chunks = 0
 **/